import { VisitName } from '@models/study';
import { MdsOptionGeneric } from './utility';

export const emptyMerchantOption: MdsOptionGeneric<number> = { value: 0, viewValue: 'Unspecified' };

// TODO: replace other usages of 1e6 and -1e6 with these constants
export const minNumberValue = -1e6;
export const maxNumberValue = 1e6;

export const maxDateValue = new Date('2099-12-31T23:59:59.999');
export const minDateValue = new Date('1900-01-01T00:00:00.000');

export const emptyValue: string = 'Unspecified';

export const emptyVisitName: VisitName = {
    id: null,
    name: emptyValue,
    studyId: null,
    scheduled: false,
    sortOrder: 0,
    visitGroup: null,
    visitGroupId: null,
};
